import Glide from "@glidejs/glide";

if (document.querySelector(".glide")) {
    document.querySelectorAll(".glide").forEach((glide) => {
        new Glide(glide, {
            type: "carousel",
            animationDuration: 600,
            animationTimingFunc: "cubic-bezier(0.22, 1, 0.36, 1)",
            startAt: 0,
            perView: 4,
            gap: 24,
            breakpoints: {
                425: {
                    perView: 1,
                    peek: {
                        after: 150,
                        before: 0,
                    },
                },
                540: {
                    perView: 2,
                    peek: {
                        after: 100,
                        before: 0,
                    },
                },
                850: {
                    perView: 2,
                    peek: {
                        after: 150,
                        before: 0,
                    },
                },
            },
        }).mount();
    })
}

if (document.querySelector(".blog-carousel")) {
    new Glide(".blog-carousel", {
        type: "carousel",
        animationDuration: 600,
        animationTimingFunc: "cubic-bezier(0.22, 1, 0.36, 1)",
        startAt: 0,
        perView: 3,
        gap: 24,
        breakpoints: {
            425: {
                perView: 1,
                peek: {
                    after: 150,
                    before: 0,
                },
            },
            540: {
                perView: 2,
                peek: {
                    after: 100,
                    before: 0,
                },
            },
            850: {
                perView: 2,
                peek: {
                    after: 150,
                    before: 0,
                },
            },
        },
    }).mount();
}
